import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
export default {
	methods: {
		async getUserInfo(){
			let param = {
				userId: this.userId,
				followUserId: this.followUserId
			}
			ajaxParam(param)
			const res = await post('v1/circle/followUserInfo', qs.stringify(param))
			if(res.data.code==200){
				this.$set(this,'item',res.data.entity)
				console.log(this.item)
			} else {
				this.$message.error(res.data.msg)
			}
		}
	}
}